// FROZEN — the legacy positional cf-id allocator. Do NOT change its behavior.
// Used ONLY by io/migrateCfIds.ts to reproduce the ids an old saved doc rendered,
// so they can be mapped to the new content-hash ids. The live allocator is
// injectCfNodeIds in slot-schema.ts (content-hash as of the cf-id migration).

import { parseFragment } from './parseFragment';

/**
 * Walk `root` in document order and return the legacy positional id each element
 * WOULD have received: existing ids preserved; new ids `cf-${n}` skipping
 * in-use values. Mirrors the pre-migration injectCfNodeIds element-for-element.
 * Returns a parallel array aligned to `root.querySelectorAll('*')`.
 */
export function positionalIdsFor(html: string): { root: HTMLElement; ids: string[] } {
  const root = parseFragment(html);
  const all = Array.from(root.querySelectorAll('*'));
  const used = new Set<string>();
  for (const el of all) {
    const id = el.getAttribute('data-cf-id');
    if (id) used.add(id);
  }
  let counter = 0;
  const fresh = (): string => {
    let id = `cf-${counter++}`;
    while (used.has(id)) id = `cf-${counter++}`;
    used.add(id);
    return id;
  };
  const ids = all.map((el) => el.getAttribute('data-cf-id') ?? fresh());
  return { root, ids };
}
